import React, {
  Component,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import Select from '../Select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faSignIn, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { Input } from 'reactstrap'
import useFocus from './useFocus'
import './styles/UsersManagement.css'
import { setArchivedFilterTrue } from 'store/Users/actions'
import { useSelector } from 'react-redux'

export const getAccess = (access, language) => {
  switch (access) {
    case 1:
      return 'admin'
    case 2:
      return 'course_manager'
    case 3:
      return 'employee'
    case 4:
      return 'area_admin'
  }
}

export const getAccessTypes = (data) => {
  return (
    data || [
      { name: 'Admin', access: 1 },
      { name: 'Area Admin', access: 4 },
      { name: 'Course Manager', access: 2 },
      { name: 'Employee', access: 3 },
    ]
  )
}

export const getStatusTypes = () => [
  { name: 'Active', status: 1 },
  { name: 'Term', status: 2 },
  { name: 'Leave of Absence', status: 3 },
]

export const DeleteCellRenderer = () => (
  <div className='action-icon h-100 d-flex justify-content-center align-items-center'>
    <FontAwesomeIcon icon={faTrash} style={{ height: '16px', width: '18px' }} />
  </div>
)
export const ProxyCellRenderer = () => (
  <div className='h-100 action-icon d-flex justify-content-center align-items-center'>
    <FontAwesomeIcon
      icon={faSignIn}
      style={{ height: '16px', width: '18px' }}
    />
  </div>
)
export const EditCellRenderer = (params) => (
  <Link
    // to={`/settings/users/${params.data.id}`}
    to={`/settings/users/${params.data.id}`}
    className='text-grey h-100 d-flex justify-content-center align-items-center'
    title={`Edit ${params.data.first_name} ${params.data.last_name}`}
  >
    <FontAwesomeIcon
      icon={faEdit}
      style={{ height: '16px', width: '18px', color: '#8889AA' }}
    />
  </Link>
)
export const FirstNameFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [firstNameFilter, setFirstNameFilter] = useState(
    activeFilters?.first_name?.value
  )
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setFirstNameFilter(props.context.firstNameFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
      clearFilter() {
        setFirstNameFilter('')
        props.context.setFirstNameFilter('')
        props.filterChangedCallback()
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('first_name')) {
      focusRef.current.value = ''
      setFirstNameFilter('')
    }
  }, [activeFilters])

  const setFirstName = (value) => {
    setFirstNameFilter(value)
    props.context.setFirstNameFilter(value)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            defaultValue={firstNameFilter}
            ref={focusRef}
            autoFocus
            onChange={(event) => setFirstName(event.target.value)}
            className='ag-filter-filter'
            // style={{ height: "50xp", padding: "5px 0px" }}
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})

export const LastNameFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [lastNameFilter, setLastNameFilter] = useState(
    activeFilters?.last_name?.value
  )

  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setLastNameFilter(props.context.lastNameFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('last_name')) {
      focusRef.current.value = ''
      setLastNameFilter('')
    }
  }, [activeFilters])

  const setLastName = (value) => {
    setLastNameFilter(value)

    props.context.setLastNameFilter(value)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            ref={focusRef}
            defaultValue={lastNameFilter}
            autoFocus
            onChange={(event) => {
              setLastName(event.target.value)
            }}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})

export const EmailFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [emailFilter, setEmailFilter] = useState(activeFilters?.email?.value)
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setEmailFilter(props.context.emailFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('email')) {
      focusRef.current.value = ''
      setEmailFilter('')
    }
  }, [activeFilters])

  const setEmail = (value) => {
    setEmailFilter(value)
    props.context.setEmailFilter(value)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            defaultValue={emailFilter}
            ref={focusRef}
            autoFocus
            onChange={(event) => setEmail(event.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})
export const UsernameFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [usernameFilter, setUsernameFilter] = useState(
    activeFilters?.username?.value
  )
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setUsernameFilter(props.context.usernameFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('username')) {
      focusRef.current.value = ''
      setUsernameFilter('')
    }
  }, [activeFilters])

  const setUsername = (value) => {
    setUsernameFilter(value)
    props.context.setUsernameFilter(value)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }
  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            defaultValue={usernameFilter}
            ref={focusRef}
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})
export const ExternalIdFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [externalIdFilter, setExternalIdFilter] = useState(
    activeFilters?.external_id?.value
  )

  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setExternalIdFilter(props.context.externalIdFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  // useEffect(() => {
  //   // Set input value from object if it's not empty
  //   if (activeFilters?.external_id?.value !== '') {
  //     setExternalIdFilter(activeFilters?.external_id?.value)
  //   }
  // }, []) // Emp

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('external_id')) {
      focusRef.current.value = ''
      setExternalIdFilter('')
    }
  }, [activeFilters])

  const setExternalId = (value) => {
    setExternalIdFilter(value)
    props.context.setExternalIdFilter(value)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            defaultValue={externalIdFilter}
            ref={focusRef}
            autoFocus
            onChange={(event) => setExternalId(event.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})
export const LocationGroupsFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [selectedLocationGroups, setSelectedLocationGroups] = useState('')
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setSelectedLocationGroups(props.context.locationGroupsFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  const selectLocationGroups = (group) => {
    setSelectedLocationGroups(group)
    props.filterChangedCallback()
    props.context.setLocationGroupsFilter(group)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('group')) {
      setSelectedLocationGroups('')
    }
  }, [activeFilters])

  let style = {
    width: '300px',
    height: '365px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <Select
        ref={focusRef}
        options={props.context.allLocationGroups}
        selectedOptions={selectedLocationGroups}
        onChange={selectLocationGroups}
        multi='true'
      />
    </div>
  )
})
export const RolesFilter = (props) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [selectedAccess, setSelectedAccess] = useState([])
  const [selectedRoles, setSelectedRoles] = useState([])

  const afterGuiAttached = () => {
    setSelectedAccess(props.context.rolesFilter)
  }
  useEffect(() => {
    props.filterChangedCallback()
  }, [])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('role')) {
      setSelectedRoles([])
      setSelectedAccess([])
    }
  }, [activeFilters])

  const isFilterActive = () => {
    return false
  }

  const doesFilterPass = () => {
    return true
  }

  const selectRoles = (roles) => {
    setSelectedRoles(roles)
    props.context.setRolesFilter(roles)
    props.filterChangedCallback()
  }

  let style = {
    width: '300px',
    height: '365px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <Select
        options={props.context.allRoles}
        selectedOptions={selectedRoles}
        onChange={selectRoles}
        multi='true'
      />
    </div>
  )
}
export const AccessFilter = (props) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [selectedAccess, setSelectedAccess] = useState([])
  const afterGuiAttached = (params) => {
    setSelectedAccess(props.context.accessFilter)
  }

  const selectAccess = (access) => {
    setSelectedAccess(access)
    props.context.setAccessFilter(access)
    props.filterChangedCallback()
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('access')) {
      setSelectedAccess([])
    }
  }, [activeFilters])

  const isFilterActive = () => {
    return false
  }

  const doesFilterPass = () => {
    return true
  }

  let style = {
    width: '300px',
    height: '365px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <Select
        options={getAccessTypes(props.colDef.accessOptions || null)}
        selectedOptions={selectedAccess}
        onChange={selectAccess}
        multi='false'
      />
    </div>
  )
}
export const StatusFilter = (props) => {
  const dispatch = useDispatch()
  const [showActiveUsers, setShowActiveUsers] = useState(false)
  const [showTermUsers, setShowTermUsers] = useState(false)
  const [showLoaUsers, setShowLoaUsers] = useState(false)

  const { activeFilters } = useSelector((state) => state.users)

  const afterGuiAttached = (params) => {
    setStatusFilter()
  }

  const setStatusFilter = () => {
    if (props.context.statusFilter) {
      let statusFilter = props.context.statusFilter.split(',')
      // statusFilter.includes(1) ? setShowActiveUsers(true) : null;
      // statusFilter.includes(2) ? setShowTermUsers(true) : null;
      // statusFilter.includes(3) ? setShowLoaUsers(true) : null;
    } else {
      setShowActiveUsers(false)
      setShowTermUsers(false)
      setShowLoaUsers(false)
    }
  }

  const toggleActiveUsers = () => {
    props.context.setStatusFilter(!showActiveUsers, showTermUsers, showLoaUsers)
    setShowActiveUsers((activeUsers) => !activeUsers)
  }

  const toggleTermUsers = () => {
    props.context.setStatusFilter(showActiveUsers, !showTermUsers, showLoaUsers)
    setShowTermUsers((termUsers) => !termUsers)
  }

  const toggleLoaUsers = () => {
    props.context.setStatusFilter(showActiveUsers, showTermUsers, !showLoaUsers)
    setShowLoaUsers((loaUsers) => !loaUsers)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('status')) {
      setShowActiveUsers(false)
      setShowTermUsers(false)
      setShowLoaUsers(false)
    }
  }, [activeFilters])

  const isFilterActive = () => {
    return false
  }

  const doesFilterPass = () => {
    return true
  }

  let style = {
    width: '300px',
    height: '150px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='status-wrapper'>
        <label>Show:</label>
        <label>
          <input
            type='checkbox'
            onChange={toggleActiveUsers}
            checked={showActiveUsers || false}
          />
          <span>Active</span>
        </label>
        <label>
          <input
            type='checkbox'
            onChange={toggleTermUsers}
            checked={showTermUsers || false}
          />
          <span>Term</span>
        </label>
        <label>
          <input
            type='checkbox'
            onChange={toggleLoaUsers}
            checked={showLoaUsers || false}
          />
          <span>Leave Of Absence</span>
        </label>
      </div>
      {/* <Select
          options={getStatusTypes()}
          selectedOptions={selectedStatus}
          onChange={selectStatus}
        /> */}
    </div>
  )
}
export const ArchivedFilter = (props) => {
  const [showingNonArchivedUsers, setShowingNonArchivedUsers] = useState(false)
  const [showingArchivedUsers, setShowingArchivedUsers] = useState(false)
  const dispatch = useDispatch()

  const { activeFilters } = useSelector((state) => state.users)

  const afterGuiAttached = useCallback(() => {
    const setArchivedFilterState = () => {
      if (props.api.frameworkComponentWrapper) {
        if (props.context.archivedFilter === '1') {
          setShowingNonArchivedUsers(false)
          setShowingArchivedUsers(true)
        } else if (props.context.archivedFilter === '0') {
          setShowingNonArchivedUsers(true)
          setShowingArchivedUsers(false)
        } else if (props.context.archivedFilter === '0,1') {
          setShowingNonArchivedUsers(true)
          setShowingArchivedUsers(true)
        }
      } else {
        setShowingNonArchivedUsers(false)
        setShowingArchivedUsers(false)
      }
    }
    setArchivedFilterState()
  }, [props.api.frameworkComponentWrapper])
  // const afterGuiAttached = (params) => {
  //   setArchivedFilterState();
  // };

  useEffect(() => {
    afterGuiAttached()
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('archived')) {
      setShowingNonArchivedUsers(false)
      setShowingArchivedUsers(false)
    }
  }, [activeFilters])

  const isFilterActive = () => {
    return false
  }

  const doesFilterPass = () => {
    return true
  }

  const toggleShowNonArchivedUsers = () => {
    props.context.setArchivedFilter(
      !showingNonArchivedUsers,
      showingArchivedUsers
    )
    setShowingNonArchivedUsers((nonArchUsers) => !nonArchUsers)
  }

  const toggleShowArchivedUsers = () => {
    props.context.setArchivedFilter(
      showingNonArchivedUsers,
      !showingArchivedUsers
    )
    setShowingArchivedUsers((archUsers) => !archUsers)
  }

  let style = {
    width: '300px',
    height: '120px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <div className='archived-wrapper'>
            <label>Show:</label>
            <label>
              <input
                type='checkbox'
                // ref={inputRef}
                id='toggleShowNonArchivedUsers'
                name='toggleShowNonArchivedUsers'
                onChange={toggleShowNonArchivedUsers}
                checked={showingNonArchivedUsers || false}
              />
              <span>Non Archived</span>
            </label>
            <label>
              <input
                type='checkbox'
                // ref={inputRef}
                id='toggleShowArchivedUsers'
                name='toggleShowArchivedUsers'
                onChange={() => {
                  toggleShowArchivedUsers()
                  // dispatch(setArchivedFilterTrue())
                }}
                checked={showingArchivedUsers || false}
              />
              <span>Archived</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
export const ExtraField1Filter = forwardRef((props, ref) => {
  const [extraField1Filter, setExtraField1Filter] = useState('')
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setExtraField1Filter(
          props.api.frameworkComponentWrapper.externalIdFilter
        )
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  const setExtraField1 = (value) => {
    setExtraField1Filter(value, () => {
      props.context.setExtraField1Filter(value)
      props.filterChangedCallback()
    })
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            value={extraField1Filter}
            ref={focusRef}
            autoFocus
            onChange={(event) => setExtraField1(event.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})
export const ExtraField2Filter = forwardRef((props, ref) => {
  const [extraField2Filter, setExtraField2Filter] = useState('')
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setExtraField2Filter(props.context.externalIdFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  const setExtraField2 = (value) => {
    setExtraField2Filter(value, () => {
      props.context.setExtraField2Filter(value)
      props.filterChangedCallback()
    })
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <input
            value={extraField2Filter}
            ref={focusRef}
            autoFocus
            onChange={(event) => setExtraField2(event.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
})
export const StoreFilter = forwardRef((props, ref) => {
  const { activeFilters } = useSelector((state) => state.users)

  const [selectedStores, setSelectedStores] = useState('')
  const focusRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      afterGuiAttached(params) {
        focusRef.current.focus()
        setSelectedStores(props.context.storesFilter)
      },
      isFilterActive() {
        return false
      },
      doesFilterPass() {
        return true
      },
    }
  })

  const selectStores = (access) => {
    setSelectedStores(access)
    props.filterChangedCallback()
    props.context.setStoresFilter(access)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [props])

  useEffect(() => {
    if (!activeFilters.hasOwnProperty('store')) {
      setSelectedStores('')
    }
  }, [activeFilters])

  let style = {
    width: '300px',
    height: '365px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <Select
        ref={focusRef}
        options={props.context.allStores}
        selectedOptions={selectedStores}
        onChange={selectStores}
        multi='true'
      />
    </div>
  )
})
export const LastLoginFilter = (props) => {
  const [lastLoginFilter, setLastLoginFilter] = useState('')
  const [inputRef, setInputFocus] = useFocus()

  const afterGuiAttached = (params) => {
    setLastLoginFilter(props.api.frameworkComponentWrapper.lastLoginFilter)
  }

  const isFilterActive = () => {
    return false
  }

  const doesFilterPass = () => {
    return true
  }

  useEffect(() => {
    setInputFocus()
    props.filterChangedCallback()
  }, [])

  const setLastLogin = (value) => {
    setLastLoginFilter(value, () => {
      props.context.setLastLoginFilter(value)
      props.filterChangedCallback()
    })
  }

  let style = {
    width: '300px',
    height: '60px',
    padding: '10px',
    overflow: 'hidden',
  }

  return (
    <div style={style}>
      <div className='ag-filter-body'>
        <div className='ag-input-wrapper'>
          <Input
            value={lastLoginFilter}
            ref={inputRef}
            autoFocus
            onChange={(event) => setLastLogin(event.target.value)}
            className='ag-filter-filter'
            type='text'
            placeholder='Filter...'
          />
        </div>
      </div>
    </div>
  )
}
